import { Component, ChangeDetectionStrategy, input } from "@angular/core";

@Component({
    selector: "h-korean-legal-links",
    templateUrl: "./korean-legal-links.component.html",
    styleUrl: "./korean-legal-links.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        "[class.light]": "hasLightCopyright()",
    },
})
export class KoreanLegalLinksComponent {
    public hasLightCopyright = input<boolean>(false);
}
